export enum FirmwareUpdateStatus {
  DOWNLOADING_STARTED = 'downloading_started',
  DOWNLOADING_FINISHED = 'downloading_finished',
  DOWNLOADING_FAILED = 'downloading_failed',
  STARTED = 'started',
  FINISHED = 'finished',
  FAILED = 'failed',
}

export interface FirmwareUpdateStatusEvent {
  deviceId: string;
  status: FirmwareUpdateStatus;
  firmwareVersion: string;
  url?: string;
  reason?: string;
}
